import { ScaleDevice } from "../types/scaleDevice";
import { createApiStore } from "./genericStore";
import api from "../service/api";

const baseStore = createApiStore<ScaleDevice>("/scale-device");

export const useScaleDeviceStore = () => {
  const store = baseStore();

  const testConnection = async (deviceId: number) => {
    return await api.post(`/scale-device/${deviceId}/test`);
  };

  return {
    ...store,
    testConnection
  };
};
